module.exports = __webpack_public_path__ + "static/media/3.99ebcc42.jpg";